// extracted by mini-css-extract-plugin
export default {"root":"ChangeEmail_root__F1dIV","container":"ChangeEmail_container__2ZYTl","form":"ChangeEmail_form__OCokX"};